<template>
  <former-container class="vehicles-list-filters">
    <former-select
      v-for="field in fields"
      :key="field.id"
      class="vehicles-list-filters-item"
      :field="field"
      :value="field.value"
      inline
      @change="value => change(field.id, value)"
    />
  </former-container>
</template>

<script>
  import { mapState } from 'vuex';

  import optionsHelper from '@cordel/helpers/form/select/options';
  import { select } from '@/_CRUDL/helpers/form/fields';

  import preload from '@/helpers/mixins/preload';
  import former from '@/helpers/mixins/former';

  import { INITIAL_VEHICLE_FILTERS } from '@/store/modules/vehicle-models';

  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSelect from '@/components/Former/Field/Select.vue';

  export default {
    name: 'VehiclesSearchFilter',
    components: {
      FormerContainer,
      FormerSelect,
    },
    mixins: [
      former,
      preload,
    ],
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    computed: {
      ...mapState([
        'vehicleModels',
        'vehicleFilters',
      ]),

      fields() {
        const {
          active,
          publish,
          vehicle_type_id: typeID,
          fuel_id: fuelID,
          vehicle_brand_id: brandID,
          year_start: yearStart,
          year_end: yearEnd,
          has_molicar_code: molicar,
          has_fipe_code: fipe,
        } = this.vehicleModels.list.filters;

        const {
          active: activeOptions,
          fuel: fuelOptions,
          has_fipe_code: fipeCodeOptions,
          has_molicar_code: molicarCodeOptions,
          publish: publishOptions,
          vehicle_brand: brandOptions,
          vehicle_type: typeOptions,
          year_end: yearEndOptions,
          year_start: yearStartOptions,
        } = this.vehicleFilters.list.items;

        return {
          active: {
            ...select,
            id: 'active',
            placeholder: 'Situação',
            size: 2,
            value: active || null,
            options: optionsHelper(activeOptions, { manipulate: v => String(v) }),
          },
          publish: {
            ...select,
            id: 'publish',
            placeholder: 'Loja online',
            value: publish || null,
            options: optionsHelper(publishOptions, { manipulate: v => String(v) }),
          },
          vehicle_type_id: {
            ...select,
            id: 'vehicle_type_id',
            placeholder: 'Tipo de veículo',
            value: typeID || null,
            options: optionsHelper(typeOptions, { manipulate: v => String(v) }),
          },
          fuel_id: {
            ...select,
            id: 'fuel_id',
            placeholder: 'Combustível',
            value: fuelID || null,
            options: optionsHelper(fuelOptions, { manipulate: v => String(v) }),
          },
          vehicle_brand_id: {
            ...select,
            id: 'vehicle_brand_id',
            placeholder: 'Marca',
            value: brandID || null,
            options: optionsHelper(brandOptions, { manipulate: v => String(v) }),
          },
          year_start: {
            ...select,
            id: 'year_start',
            placeholder: 'Ano de modelo inicial',
            value: yearStart || null,
            options: optionsHelper(yearStartOptions, { manipulate: v => String(v) }),
          },
          year_end: {
            ...select,
            id: 'year_end',
            placeholder: 'Ano de modelo final',
            value: yearEnd || null,
            options: optionsHelper(yearEndOptions, { manipulate: v => String(v) }),
          },
          has_molicar_code: {
            ...select,
            id: 'has_molicar_code',
            placeholder: 'Molicar',
            size: 2,
            value: molicar || null,
            options: optionsHelper(molicarCodeOptions, { manipulate: v => String(v) }),
          },
          has_fipe_code: {
            ...select,
            id: 'has_fipe_code',
            placeholder: 'Fipe',
            value: fipe || null,
            options: optionsHelper(fipeCodeOptions, { manipulate: v => String(v) }),
          },
        };
      },
    },
    mounted() {
      this.preloadVehicleFilters();
    },
    beforeDestroy() {
      this.$emit('change', {
        ...INITIAL_VEHICLE_FILTERS,
      });
    },
    methods: {
      change(id, value) {
        let updating = value;

        if (Array.isArray(INITIAL_VEHICLE_FILTERS[id])) {
          updating = updating ? [updating] : [];
        }

        this.$emit('change', {
          [id]: updating,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .vehicles-list-filters {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: var(--cordel-spacing-s) var(--product--pwa--horizontal) 0;

    > :nth-child(-n + 4) {
      flex-basis: 20%;
    }

    > :nth-child(n+5):nth-child(-n + 7) {
      flex-basis: 25%;
    }

    > :nth-child(n + 7) {
      flex-basis: 33%;
    }

    @media all and (min-width: $breakpoint-desktop) {
      align-items: flex-start;
      justify-content: stretch;
      flex-wrap: wrap;
      flex-direction: row;
      margin: 0 calc(var(--product--pwa--horizontal) - #{$gutter-small});
    }
  }

  .vehicles-list-filters-item {
    flex: 1;
    margin: $gutter-smaller 0;

    @media all and (min-width: $breakpoint-desktop) {
      flex: auto;
      margin: $gutter-smaller $gutter-small $gutter-smallest;
    }

    // IE hack
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      flex: 1;
    }
  }
</style>
